<div class="row">
  <div class="col-md-12 d-flex justify-content-between">
    <div class="heading">
      <h4>{{selecteTyreId ? 'Update Tyre Size':'Add Tyre Size'}}</h4>
    </div>
  </div>
</div>
<section class="content">
  <div class="container card">
    <form (ngSubmit)="saveTyreData()" [formGroup]="addTyreForm">
      <div class="row pt-3 g-3">
        <div class="col-6">
          <label for="tyreSize">Tyre Size<span class="text-danger">*</span></label>
          <input type="text" class="form-control default-form-group-border" id="tyreSize"
            formControlName="tyreSize" required placeholder="Eg: 195/55 R16" readonly>
          </div>

          <div class="col-md-6">
            <label for="category">Vehical Type<span class="text-danger">*</span></label>
            <select class="form-select default-form-group-border" id="category" formControlName="category"
              (change)="onChangeVehical($event)">
              <option value="" disabled>Select Vehicle Type</option>
              @for (vehical of vehicleFormats; track vehical) {
                <option [value]="vehical.id">
                {{vehical.name}}</option>
              }
            </select>
            @if (addTyreForm.get('category')?.invalid && (addTyreForm.get('category')?.dirty || addTyreForm.get('category')?.touched)) {
              <div class="errorText"
                >
                @if (addTyreForm.controls['category'].errors?.['required']) {
                  <div>
                    <small class="text-danger">Vehical type is required</small>
                  </div>
                }
              </div>
            }
          </div>

          @if (visibleFields.aspectRatio.visible) {
            <div class="col-6">
              <label for="aspectRatio">Aspect Ratio @if (visibleFields.aspectRatio.required) {
                <span class="text-danger">*</span>
              }</label>
              <input type="text" class="form-control default-form-group-border" id="aspectRatio" formControlName="aspectRatio"
                placeholder="Eg: 100" type="number">
                @if (addTyreForm.get('aspectRatio')?.invalid && (addTyreForm.get('aspectRatio')?.dirty || addTyreForm.get('aspectRatio')?.touched)) {
                  <div class="errorText"
                    >
                    @if (addTyreForm.controls['aspectRatio'].errors?.['required']) {
                      <div>
                        <small class="text-danger">Aspect ratio is required</small>
                      </div>
                    }
                  </div>
                }
              </div>
            }

            @if (visibleFields.constructionType.visible) {
              <div class="col-6">
                <label for="constructionType">Tyre Construction @if (visibleFields.constructionType.required) {
                  <span class="text-danger">*</span>
                }</label>
                <input type="text" class="form-control default-form-group-border" id="constructionType"
                  formControlName="constructionType" placeholder="Eg: R" type="text" (input)="input($event)">
                  @if (addTyreForm.get('constructionType')?.invalid && (addTyreForm.get('constructionType')?.dirty || addTyreForm.get('constructionType')?.touched)) {
                    <div class="errorText"
                      >
                      @if (addTyreForm.controls['constructionType'].errors?.['required']) {
                        <div>
                          <small class="text-danger">Tyre construction is required</small>
                        </div>
                      }
                    </div>
                  }
                </div>
              }

              @if (visibleFields.crossSectionWidth.visible) {
                <div class="col-6">
                  <label for="crossSectionWidth">Cross Section Width @if (visibleFields.crossSectionWidth.required) {
                    <span class="text-danger">*</span>
                  }</label>
                  <input type="text" class="form-control default-form-group-border" id="crossSectionWidth"
                    formControlName="crossSectionWidth" placeholder="Eg: 195" type="number">
                    @if (addTyreForm.get('crossSectionWidth')?.invalid && (addTyreForm.get('crossSectionWidth')?.dirty || addTyreForm.get('crossSectionWidth')?.touched)) {
                      <div class="errorText"
                        >
                        @if (addTyreForm.controls['crossSectionWidth'].errors?.['required']) {
                          <div>
                            <small class="text-danger">width is required</small>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                @if (visibleFields.rimSize.visible) {
                  <div class="col-6">
                    <label for="rimSize">Rim Size@if (visibleFields.rimSize.required) {
                      <span class="text-danger">*</span>
                    }</label>
                    <input type="text" class="form-control default-form-group-border" id="rimSize" formControlName="rimSize"
                      placeholder="Eg: 95" type="number">
                      @if (addTyreForm.get('rimSize')?.invalid && (addTyreForm.get('rimSize')?.dirty || addTyreForm.get('rimSize')?.touched)) {
                        <div class="errorText"
                          >
                          @if (addTyreForm.controls['rimSize'].errors?.['required']) {
                            <div>
                              <small class="text-danger">Rim size is required</small>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }

                  @if (visibleFields.commercialTyre.visible) {
                    <div class="col-6">
                      <label for="commercialTyre">Commercial Tyre@if (visibleFields.commercialTyre.required) {
                        <span class="text-danger">*</span>
                      }</label>
                      <input type="text" class="form-control default-form-group-border" id="commercialTyre"
                        formControlName="commercialTyre" placeholder="commercial tyre" type="text" (input)="commertialInput($event)">
                        @if (addTyreForm.get('commercialTyre')?.invalid && (addTyreForm.get('commercialTyre')?.dirty || addTyreForm.get('commercialTyre')?.touched)) {
                          <div class="errorText"
                            >
                            @if (addTyreForm.controls['commercialTyre'].errors?.['required']) {
                              <div>
                                <small class="text-danger">Tyre construction is required</small>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    @if (visibleFields.profile.visible) {
                      <div class="col-6">
                        <label for="profile">Profile /Side Wall@if (visibleFields.profile.required) {
                          <span class="text-danger">*</span>
                        }</label>
                        <input type="text" class="form-control default-form-group-border" id="profile" formControlName="profile"
                          placeholder="profile" type="number">
                          @if (addTyreForm.get('profile')?.invalid && (addTyreForm.get('profile')?.dirty || addTyreForm.get('profile')?.touched)) {
                            <div class="errorText"
                              >
                              @if (addTyreForm.controls['profile'].errors?.['required']) {
                                <div>
                                  <small class="text-danger">Profile/Side Wall is required</small>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }

                      <div class="col-6">
                        <label for="speedSymbol">Speed</label>
                        <input type="text" class="form-control default-form-group-border" id="speedSymbol" formControlName="speedSymbol"
                          placeholder="Eg: H">
                        </div>

                        @if (!this.isAdmin) {
                          <div class="col-6">
                            <label for="maxAmount">Maximum Amount</label>
                            <input formControlName="maxAmount" id="maxAmount" type="text"
                              class="form-control default-form-group-border"  placeholder="Enter maximum amount">
                            </div>
                            <div class="col-6">
                              <label for="minAmount">Minimum Amount</label>
                              <input formControlName="minAmount" id="minAmount" type="text"
                                class="form-control default-form-group-border" placeholder="Enter minimum amount">
                              </div>
                              <div class="col-6">
                                <label for="profitability">Profitability</label>
                                <input formControlName="profitability" id="profitability" type="text"
                                  class="form-control default-form-group-border" placeholder="Enter profitability amount">
                                </div>
                              }

                            </div>

                            @if (responseMsg) {
                              <div class="text-danger">{{responseMsg}}</div>
                            }
                            <div class="row pt-3">
                              <div class="col-12 text-end p-3">
                                <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/master-data-list'">Cancel
                                </button>
                                <button type="submit" class="btn app-btn-primary" [disabled]="!addTyreForm.valid">{{selecteTyreId ?
                                  'Update': 'Submit'}}
                                  @if (isLoading) {
                                    <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                                  }</button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </section>